import React from 'react';
import PropTypes from 'prop-types';
import IncreaseBidButton from './assets/UI_ButtonAdd.png';
import SubtractBidButton from './assets/UI_ButtonSubtract.png';
import './StepperInput.css';

function StepperInput({
  disabled,
  value,
  step,
  onDecrease,
  onIncrease,
  onEdit,
  onFocus,
  icon,
  baseClassName = 'stepper-input',
  disabledButtonClass = 'btn-secondary'
}) {
  return (
    <div className="stepper-input-container">
      <button
        className={`btn ${baseClassName}-control-decrease ${
          disabled || value === 0
            ? ` ${baseClassName}-control-disabled ${disabledButtonClass}`
            : ``
        }`}
        disabled={disabled || value === 0}
        onClick={() => onDecrease(Math.max(value - step, 0))}
        type="button"
      >
        <img src={SubtractBidButton} alt="Subtract bid amount" />
      </button>
      {icon && <img className="icon-placeholder" src={icon} alt="" />}
      <input
        className={`${baseClassName}-value ${icon ? 'with-icon' : ''}`}
        disabled={disabled}
        type="number"
        maxLength={200}
        value={value ? value.toString() : null}
        onChange={onEdit}
        onFocus={onFocus}
      />
      <button
        className={`btn ${baseClassName}-control-increase ${
          disabled
            ? ` ${baseClassName}-control-disabled ${disabledButtonClass}`
            : ``
        }`}
        disabled={disabled}
        onClick={() => onIncrease(value + step)}
        type="button"
      >
        <img src={IncreaseBidButton} alt="Increase amount" />
      </button>
    </div>
  );
}

StepperInput.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.number,
  step: PropTypes.number.isRequired,
  onDecrease: PropTypes.func.isRequired,
  onIncrease: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  baseClassName: PropTypes.string,
  disabledButtonClass: PropTypes.string
};

export default StepperInput;
